module.exports = __webpack_public_path__ + "img/logo-symbol-dark.71d3bae1.png";